var React = require('react');

function ItsTimeTriangleMobile (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M54.396 50.7891L81.3232 2.10213L112.194 83.3533L54.396 50.7891Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M0.823792 49.2933L81.4161 2.10543L54.5 50.7187L0.823792 49.2933Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M0.828125 49.2969L54.4666 50.7213L112.201 83.3578L0.828125 49.2969Z","fill":"#5915C7","key":2})]);
}

ItsTimeTriangleMobile.defaultProps = {"width":"115","height":"84","viewBox":"0 0 115 84","fill":"none"};

module.exports = ItsTimeTriangleMobile;

ItsTimeTriangleMobile.default = ItsTimeTriangleMobile;
